import { render, staticRenderFns } from "./ManageMatches.vue?vue&type=template&id=7c1fe486"
import script from "./ManageMatches.vue?vue&type=script&lang=js"
export * from "./ManageMatches.vue?vue&type=script&lang=js"
import style0 from "./ManageMatches.vue?vue&type=style&index=0&id=7c1fe486&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports